  import { Component, inject, ElementRef, ViewChild } from '@angular/core';
  import { Router } from "@angular/router";
  import { BoRolesCheckService } from "../../components/rolesCheck/bo-roles-check.service";
  import { AgChart, AgChartOptions } from 'ag-charts-community';
  import { AWSLambda } from 'src/app/AWSLambda.service';
  import { MatSnackBar } from '@angular/material/snack-bar';


  import { AmplifyUser } from '@aws-amplify/ui';
  import { ConfigService } from '../../config.service';
  import { MatDialog } from '@angular/material/dialog';
  import { Auth } from 'aws-amplify';
  import { GlobalDataService } from '../../services/global-data.service';
  import { detectEnv } from 'src/app/services/Enviroment';
  import { TranslateService } from '@ngx-translate/core';
  import {   } from "../../services/auth.service";


  // Interfaces fuera de la clase
  interface HourlyData {
    count: number;
    total_charge: number;
    total_time: number;
  }

  type ResponseData = {
    [hour: string]: HourlyData;
  };

  @Component({
    selector: 'app-bakcoffice-users',
    templateUrl: './BODashboard.component.html',
    styles: [`
      .loading-mask {
        position: fixed;
        top: 0; left: 0; width: 100%; height: 100%;
        background-color: rgba(0,0,0,0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
      }
    `],
  })
  export class BODashboardComponent {
    showSpinner = false;
    router = inject(Router);
    rolesCheck = inject(BoRolesCheckService);
    lambda = inject(AWSLambda);
    _snackBar = inject(MatSnackBar);
    canAccess = false;
    titulo = "Dashboard Llamadas ";
    fechaInicio: string = '';
    fechaFin: string = '';
    Filtro: string = 'mes';
    telefono: string = '';
    filtrosDisponibles: string[] = ['mediahora','hora', 'dia' ,'mes',"año"];
    private chartInstance: any = null;


    //parte de transaciones
    transactionList: any[] = []; // Datos de TxUsuarios
    transactionSumary: any[] = []; // resumen mensual 
    owner: string | null = null;
    loadingTransactions: boolean = false;
    hasMoreTransactions: boolean = true;
   //parte de transaciones

    chartData: any[] = [];

    @ViewChild('Detallecostollamadas', { static: true }) chartContainer!: ElementRef;
    @ViewChild('transactionChart', { static: true }) transactionChartContainer!: ElementRef;
    @ViewChild('transactionSumaryChart', { static: true }) transactionSumaryChartContainer!: ElementRef;
    transactionChartInstance: any = null;
    transactionsumaryChartInstance: any = null;

    chartOptions: AgChartOptions = {
    container: undefined,
    title: {
      text: this.titulo,
    },
    data: [],

    series: [
      {
        type: 'line',
        xKey: 'hour',
        yKey: 'count',
        yName: 'Cantidad',
        strokeWidth: 3,
        marker: {
          shape: 'circle',
        },
      },
      {
        type: 'line',
        xKey: 'hour',
        yKey: 'total_charge',
        yName: 'Carga Total',
        strokeWidth: 3,
        marker: {
          shape: 'diamond',
        },
      },
    ],

    axes: [
      {
        type: 'category',
        position: 'bottom',
        title: { text: 'Hora' },
      },
      {
        type: 'number',
        position: 'left',
        keys: ['count'],
        title: {
          text: 'Cantidad',
        },
        label: {
          formatter: (params) => params.value.toString(),
        },
      },
      {
        type: 'number',
        position: 'right',
        keys: ['total_charge'],
        title: {
          text: 'Carga Total',
        },
        label: {
          formatter: (params) => params.value.toFixed(2),
        },
      },
    ],

    legend: {
      position: 'bottom',
      item: {
        marker: {
          shape: 'square',
          strokeWidth: 0,
        },
      },
    },
    };

    transactionChartOptions: AgChartOptions = {
      container: undefined,
      title: {
        text: 'Resumen de Transacciones',
      },
      data: [],
      series: [
        {type: 'column',xKey: 'user',yKey: 'Call',yName: 'Call (€)',stacked: true,},
        {type: 'column',xKey: 'user',yKey: 'Esim',yName: 'Esim (€)',stacked: true,},
        {type: 'column',xKey: 'user',yKey: 'Transferencia',yName: 'Transferencia (€)',stacked: true,},
      ],
      legend: {
        position: 'bottom',
      },
    };
    
    transactionsumaryChartOptions:AgChartOptions = {
        container: undefined,
        title: { text: 'Evolución Mensual de Transacciones' },
        data: [],
        series: [
          {type: 'column',xKey: 'mes',yKey: 'esimAmount',yName: 'eSIM (€)',stacked: true,},
          {type: 'column',xKey: 'mes',yKey: 'callAmount',yName: 'Llamadas (€)',stacked: true,},
          {type: 'column',xKey: 'mes',yKey: 'transferenciaAmount',yName: 'Transferencias (€)',stacked: true,},

          {type: 'line',xKey: 'mes',yKey: 'esimCount',yName: 'eSIM (#)'           ,strokeWidth: 3,marker: { shape: 'circle' },},// eje izquierdo 
          {type: 'line',xKey: 'mes',yKey: 'callCount',yName: 'Llamadas (#)'       ,strokeWidth: 3,marker: { shape: 'square' },},
          {type: 'line',xKey: 'mes',yKey: 'transferenciaCount',yName: 'Transferencias (#)',strokeWidth: 3,marker: { shape: 'diamond' },},
          {type: 'line',xKey: 'mes',yKey: 'activos',yName: 'Usuarios (#)'         ,strokeWidth: 3,marker: { shape: 'triangle' },},
          {type: 'line',xKey: 'mes',yKey: 'activosEsim',yName: 'activos Esim (#)' ,strokeWidth: 3,marker: { shape: 'cross' },},
          {type: 'line',xKey: 'mes',yKey: 'activosCall',yName: 'activos Call (#)' ,strokeWidth: 3,marker: { shape: 'plus' },},  
        ],
        axes: [
          {
            type: 'category',
            position: 'bottom',
            title: { text: 'Mes' },
          },
          {
            type: 'number',
            position: 'left',
            keys: ['esimCount', 'callCount', 'transferenciaCount',"activos","activosEsim","activosCall"],
            title: { text: 'Cantidad de Transacciones' },
          },
          {
            type: 'number',
            position: 'right',
            keys: ['esimAmount', 'callAmount', 'transferenciaAmount'],
            title: { text: 'Monto (€)' },
            label: { formatter: (params) => `${params.value.toFixed(2)}€` },
          },
        ],
        legend: {
          position: 'bottom',
        },
      };

    async ngOnInit() {
      this.canAccess = await this.rolesCheck.checkAccess();
      if (!this.canAccess) {
        return;
      }

    

      // 🔹 Fecha actual
      const today = new Date();

      // 🔹 Primer día del mes actual
      const firstDay = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), 1, 0, 0, 0));

      // 🔹 Último día del mes actual (día 0 del mes siguiente)
      const lastDay = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth() + 1, 0, 23, 59, 59));

      // 🔹 Formatear fechas en ISO para enviar a la API
      const fecha_ini = firstDay.toISOString();
      const fecha_fin = lastDay.toISOString();

      // 🔹 Mostrar las fechas en los inputs (solo fecha, sin hora)
      this.fechaInicio = fecha_ini.split('T')[0];
      this.fechaFin = fecha_fin.split('T')[0];

      // 🔹 Filtro por defecto: mensual
      this.Filtro = 'mes';

      // Cargar llamadas y crear grafico
      await this.crearGrafico(this.Filtro, fecha_ini, fecha_fin,undefined);

      // Cargar transacciones
      await this.getTransactionList(undefined, this.fechaInicio, this.fechaFin);
      // Cargar transaccionessumary
      await this.getTransactionsumary(undefined, this.fechaInicio, this.fechaFin);
    }

    

    async crearGrafico(filtro: string, fecha_ini: string, fecha_fin: string, phoneNumber?: string) {
      this.chartOptions.container = this.chartContainer.nativeElement;

      const queryParams: any = {
        filtro,
        fecha_ini,
        fecha_fin,
      };

      if (phoneNumber) {
        queryParams.phoneNumber = phoneNumber;
      }

      const response = await this.lambda.getLambdaFunction('lambda', '/get/datacalls', {
        queryStringParameters: queryParams,
      });

      let responseData: ResponseData = {};
      try {
        if (response && typeof response.body === 'string') {
          responseData = JSON.parse(response.body) as ResponseData;
        } else if (response) {
          responseData = response as ResponseData;
        }
      } catch (e) {
        console.error('Error parsing response:', e);
        return;
      }

      this.chartOptions.title = {
        text: "detalle llamadas por " + filtro,
      };
      

      const sortedKeys = Object.keys(responseData)
        .map(key => {
          const sortKey = parseInt(key, 10);

          // 🔤 Formatear clave tipo "0030" => "00:30"
          let displayKey = key;
          if (filtro === 'mediahora' && key.length === 4) {
            const hh = key.substring(0, 2);
            const mm = key.substring(2, 4);
            displayKey = `${hh}:${mm}`;
          }

          return { displayKey, rawKey: key, sortKey };
        })
        .sort((a, b) => a.sortKey - b.sortKey);

      this.chartData = sortedKeys.map(({ displayKey, rawKey }) => ({
        hour: displayKey,
        count: responseData[rawKey]?.count ?? 0,
        total_charge: responseData[rawKey]?.total_charge ?? 0,
        total_time: responseData[rawKey]?.total_time ?? 0,
      }));

      this.chartOptions.data = this.chartData;

      if (this.chartInstance) {
        AgChart.update(this.chartInstance, this.chartOptions);
      } else {
        this.chartInstance = AgChart.create(this.chartOptions);
      }
    }

    async getTransactionList(owner?: string, fechaInicio?: string, fechaFin?: string): Promise<void> {
        this.loadingTransactions = true;
        this.transactionList = []

        const queryParams: any = {};
        if (owner) queryParams.owner = owner;
        if (fechaInicio) queryParams.fechaInicio = fechaInicio;
        if (fechaFin) queryParams.fechaFin = fechaFin;

        queryParams.resumen = "true"; // para obtener datos resumidos
        queryParams.filtro = ""
      

        console.log(queryParams);
        try {
            const response = await this.lambda.getLambdaFunction('lambda', '/get/TxUsers', {
                queryStringParameters: queryParams,
            });

            if (response?.data && Array.isArray(response.data)) {
                this.transactionList = [...this.transactionList, ...response.data];
                 this.updateTransactionChart();
            } else {
                this.hasMoreTransactions = false;
            }
        } catch (err) {
            console.error('Error al obtener transacciones:', err);
        } finally {
            this.loadingTransactions = false;
        }
    }

    async getTransactionsumary(owner?: string, fechaInicio?: string, fechaFin?: string): Promise<void> {
        this.loadingTransactions = true;
        this.transactionSumary = []

        const queryParams: any = {};
        if (owner) queryParams.owner = owner;
        if (fechaInicio) queryParams.fechaInicio = fechaInicio;
        if (fechaFin) queryParams.fechaFin = fechaFin;

        queryParams.resumen = "true"; // para obtener datos resumidos
        queryParams.filtro = "detalle"
      

        console.log(queryParams);

        try {
            
            const response = await this.lambda.getLambdaFunction('lambda', '/get/TxUsers', {
                queryStringParameters: queryParams,
            });

            if (response?.data && typeof response.data === 'object') {
              const rawData = response.data;

              // 🔹 Convertimos el objeto en un array utilizable
              this.transactionSumary = Object.entries(rawData).map(([month, values]: [string, any]) => ({
                month,
                Activos: values.counts?.activos_total || 0,
                Activosesim: values.counts?.activos_esim || 0,
                Activoscall: values.counts?.activos_balance || 0,
                Activostx: values.counts?.activos_transferencia || 0,
                Total_amount: values.amounts?.total || 0,
                esim_amount: values.amounts?.esim || 0,
                call_amount: values.amounts?.balance || 0,
                transferencia_amount: values.amounts?.transferencia || 0,
                esim_count: values.counts?.esim || 0,
                call_count: values.counts?.balance || 0,
                transferencia_count: values.counts?.transferencia || 0,

              }));

             this.updateTransactionsumary();
            } else {
              console.warn('Respuesta vacía o inválida:', response);
            }
            
        } catch (err) {
            console.error('Error al obtener resumen transacciones:', err);
        } finally {
            this.loadingTransactions = false;
        }
    }

   updateTransactionChart(): void {
      if (!this.transactionChartContainer) return;

      // Mapeamos los datos a un formato adecuado
      const chartData = this.transactionList.map(tx => ({ 
        user: tx.full_name ,
        Call: tx.Call || 0,
        Esim: tx.esim || 0,
        Transferencia: tx.Transferencia || 0,
      }));

      this.transactionChartOptions.container = this.transactionChartContainer.nativeElement;
      this.transactionChartOptions.data = chartData;

      if (this.transactionChartInstance) {
        AgChart.update(this.transactionChartInstance, this.transactionChartOptions);
      } else {
        this.transactionChartInstance = AgChart.create(this.transactionChartOptions);
      }
    }

    updateTransactionsumary(): void {
      if (!this.transactionSumaryChartContainer) return;

      // 🔹 Convertir tu objeto (con meses como claves) en un array para AgCharts
      const chartData = this.transactionSumary.map(tx => ({
        mes: tx.month,
        esimCount: tx.esim_count || 0,
        callCount: tx.call_count || 0,
        transferenciaCount: tx.transferencia_count || 0,
        esimAmount: tx.esim_amount || 0,
        callAmount: tx.call_amount || 0,
        transferenciaAmount: tx.transferencia_amount || 0,
        activos :tx.Activos || 0,
        activosEsim :tx.Activosesim || 0,
        activosCall :tx.Activoscall || 0,
        activosTx :tx.Activostx || 0,
      }));

      console.log(chartData)

      // 🔹 Configuración del gráfico mixto (barras + líneas)
      this.transactionsumaryChartOptions.container = this.transactionSumaryChartContainer.nativeElement;
       this.transactionsumaryChartOptions.data = chartData;

      

      // 🔹 Crear o actualizar el gráfico
      if (this.transactionsumaryChartInstance) {
        AgChart.update(this.transactionsumaryChartInstance, this.transactionsumaryChartOptions);
      } else {
        this.transactionsumaryChartInstance = AgChart.create(this.transactionsumaryChartOptions);
      }
    }

    async buscarPorFechas(): Promise<void> {
      if (!this.fechaInicio || !this.fechaFin) {
        console.warn('Debe especificar ambas fechas');
        this._snackBar.open('Debe especificar ambas fechas', 'Close', { duration: 5000 });
        return;
      }

      if (new Date(this.fechaInicio) > new Date(this.fechaFin)) {
        console.warn('La fecha de inicio no puede ser mayor que la fecha de fin');
        this._snackBar.open('La fecha de inicio no puede ser mayor que la fecha de fin', 'Close', { duration: 5000 });
        return;
      }

      // Formatear fechas con horas específicas
      const fechaInicioFormatted = new Date(this.fechaInicio).toISOString().split('T')[0] + 'T00:00:00Z';
      const fechaFinFormatted = new Date(this.fechaFin).toISOString().split('T')[0] + 'T23:59:59Z';

      await this.crearGrafico(this.Filtro, fechaInicioFormatted, fechaFinFormatted, this.telefono || undefined);

      await this.getTransactionList(undefined, this.fechaInicio, this.fechaFin);
      
      await this.getTransactionsumary(undefined, this.fechaInicio, this.fechaFin);
    }

    delay(ms: number) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }

    goToUsers(): void {
      this.router.navigate(['/backoffice/users']);
    }

    goToPartners(): void {
      this.router.navigate(['/backoffice/partners']);
    }

    goToPromoCodes(): void {
      this.router.navigate(['/backoffice/promotionCodes']);
    }

    goToConverter(): void {
      this.router.navigate(['/backoffice/excelConverter']);
    }
  }
